import React from "react";
import R14, {
  Text,
  View,
  FlatList,
} from "../core";
import Touchable from "./TouchableComponent";
import NoRecordsFound from "./NoRecordsFound";
import { commonStyles } from "../assets/css/commonStyle";
import { columnTableStyles } from "../assets/css/columnTableStyles";
import { commonFontStyles } from "../assets/css/commonFontStyles";
import { customCommonStyles } from "../assets/css/customCommonStyle";
import { responsiveTableStyle } from "../assets/css/responsiveTableStyle";
import { commonMetricsStyle } from "../assets/css/commonMetricsStyle";
import DateUtils from "../utils/DateUtils";
import CommonUtility from "../utils/CommonUtility";
import Bookmarked from "./Bookmared";
import { BILL_STATUS } from "../constant/app.data.constant";
import ColumnPaginationComponent from "./ColumnPaginationComponent";


export default R14.connect(
  class DashboardColumnTableComponent extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        rowsPerPage: this.props.rowsPerPage || 10,
        search: "",
        totalRows: 0
      };
    }

    componentDidMount() {
      this.initializer();
    }

    async initializer(pageNo, searchTxt) {
      try {
        this.props.app.dm.userSession.setState({ isLoading: true });
        const { page, rowsPerPage, search = null } = this.props;
        const gridState = { page: pageNo || page, rowsPerPage, search: searchTxt || search };
        await this.props.getPageData(gridState, { totalCount: true });
        this.setState({
          rowsPerPage: this.props.rowsPerPage || 10,
          search: searchTxt || search
        });
        return false;
      } catch (error) {
      }
    }

    shortenText = (txt = "", limit = 20) => {
      if (!!txt && !isNaN(txt) && !Number.isInteger(+txt)) {
        const num = +txt;
        return num.toFixed(2);
      } else if (!!txt && txt.length > limit) {
        return txt.substring(0, limit) + '...';
      } else {
        return txt;
      }
    };

    getNestedProperty(obj, path) {
      return path.split('.').reduce((acc, part) => acc && acc[part], obj);
    }

    renderDashboardTable(pageData, pagination, onProfileIcon, toggleBookmark) {
      const firstColumnCell = ["biller.billerName", "subject", "billDate", "Due On", "dueDate"];
      const secondColumnCell = ["paymentStatus", "Amount", "billAmount", "Pay Now"];
      const amountTypeFields = ["billAmount"];
      const dateTypeFields = ["billDate", "dueDate"];
      const firstColumnCellStatic = ["Due On"];
      const secondColumnCellStatic = ["Amount"];
      const buttonsList = ["Pay Now"];
      const boldCells = ["biller.billerName", "Due On"];
      const onActionClick = onProfileIcon;
      return (
        <FlatList
          style={[
            columnTableStyles.flatListEle,
            pageData && pageData.length > 0 ? columnTableStyles.billListComponent : columnTableStyles.noItemsComponent,
            columnTableStyles.borderWidth0,
            commonStyles.marT0,
            commonStyles.marRT0,
            commonStyles.marLT0,
            commonStyles.positionRelative,
            !!pagination ? commonStyles.marginBottom16 : null,
          ]}
          data={ pageData || []}
          ListEmptyComponent={
            <View style={[commonStyles.flex1]}>
              <NoRecordsFound
                noRecords={[commonStyles.marLT0, commonStyles.marRT0]}
                message={this.props.message}
              />
            </View>
          }
          keyExtractor={(el, i) => i}
          renderItem={({ item, index }) => (
            <View key={"tableRow_" + index} style={[columnTableStyles.flexRowWithBorder, commonStyles.wordBreakWord]}>
              {/* On icons before first key */}
              <View
                style={[
                  customCommonStyles.valueInMbileBreakWord,
                  commonStyles.wordBreakWord,
                  commonStyles.flex1,
                  // commonStyles.mView,
                  columnTableStyles.mViewIconContainer,
                  !!onProfileIcon ? null : commonStyles.displayNone,
                  commonStyles.flexDirectionColumn,
                  commonStyles.alignItemsCenter
                ]}
              >
                {!!onProfileIcon && !!this.getNestedProperty(item, firstColumnCell[0]) ?
                  <Touchable onPress={() => onProfileIcon(item, "pro")}>
                    <View style={[responsiveTableStyle.userIconDiv, commonStyles.flex1, commonStyles.justifyContentCenter, commonStyles.alignItemsCenter, columnTableStyles.marginLeft0, commonStyles.marginTop5, commonStyles.marginRight5]}>
                      <Text
                        style={[
                          // commonMetricsStyle.heading6,
                          commonStyles.fontWeight500,
                          commonFontStyles.workSans,
                          commonStyles.smallHeading,
                          commonStyles.userInitial,
                          commonStyles.contentColor,
                          responsiveTableStyle.userInitial,
                          commonStyles.dBlock
                        ]}>
                        {CommonUtility.shortName(`${this.getNestedProperty(item, firstColumnCell[0])}`)}
                      </Text>
                    </View>
                  </Touchable>
                  : null}
                <View style={[commonStyles.marginRight5, commonStyles.marginTop10]} >
                  {!BILL_STATUS[item.billStatus] && !(item.status === "blocked" || item.status === "payerblocked") ? (
                    <Bookmarked
                      bookedMarkSpacing={responsiveTableStyle.bookedMarkSpacing}
                      onToggle={() => toggleBookmark(item)}
                      isBookmarked={item.bookmark}
                      bookedMarkImgStyle={[commonStyles.marLT0]}
                      bookedMarkStyle={[columnTableStyles.btnHeight]}
                    />
                  ) : null}
                </View>
              </View>
              <View
                style={[
                  columnTableStyles.tr,
                  commonStyles.flex1,
                  commonStyles.justifyContentSpaceBetween,
                  commonStyles.flexDirectionColumn,
                  commonStyles.marLT0,
                  commonStyles.marRT0,
                  commonStyles.wordBreakWord,
                  commonStyles.flexDirectionRow,
                  commonStyles.marginBottom5
                ]}
              >
                <View style={[columnTableStyles.firstColumnCellWidth]}>
                  {firstColumnCell.map((value, idx) => (
                    <Touchable key={"value_" + value + idx} style={[columnTableStyles.td, commonStyles.wordBreakWord, commonStyles.paddingRight16]} onPress={() => onProfileIcon(item, "pro")}>
                      <View style={[ commonStyles.wordBreakWord]}>
                        {value && item && this.dashboardCellRenderer(value, item, amountTypeFields, dateTypeFields, firstColumnCellStatic, buttonsList, boldCells, onActionClick)}
                      </View>
                    </Touchable>
                  ))}
                </View>
                <View style={[columnTableStyles.secondColumnCellWidth]}>
                  {secondColumnCell.map((value, idx) => (
                    <View key={"value_" + value + idx} style={[columnTableStyles.td, commonStyles.wordBreakWord, commonStyles.alignItemsEnd]}>
                      <View style={[ commonStyles.wordBreakWord]}>
                        {value && item && this.dashboardCellRenderer(value, item, amountTypeFields, dateTypeFields, secondColumnCellStatic, buttonsList, boldCells, onActionClick,)}
                      </View>
                    </View>
                  ))}
                </View>
              </View>
            </View>
          )}
        />
      )
    }

    dashboardCellRenderer(columnName = "", row = [], amountTypeFields = [], dateTypeFields = [], columnCellStatic = [], buttonsList = [], boldCells = [], onActionClick, textOnly,) {
      let text = row[columnName];
      const { showPayType, CheckPaymentAllowOrNot } = this.props;
      if (columnName.includes(".")) text = this.getNestedProperty(row, columnName);
      if (buttonsList && buttonsList.length && row && buttonsList.includes(columnName)) {
        return (
          <Touchable style={[commonStyles.marginTop8]} onPress={() => showPayType(row)} disabled={!CheckPaymentAllowOrNot(row)}>
            <View style={[responsiveTableStyle.paynowBtnInnerWrap, !CheckPaymentAllowOrNot(row) ? customCommonStyles.disabledBtn : null]}>
              <Text style={[commonMetricsStyle.heading6, commonStyles.fontWeight500, commonFontStyles.workSans, commonStyles.textAlignCenter, commonStyles.fullWidth, commonStyles.fontWeight400, commonStyles.exSmallHeading, commonStyles.flex1, commonStyles.justifyContentCenter, commonStyles.alignItemsCenter, !CheckPaymentAllowOrNot(row) ? commonStyles.lightGray : commonStyles.whiteColor, columnTableStyles.payNowBtnTxt]}>Pay Now</Text>
            </View>
          </Touchable>
        );
      }

      if (!!amountTypeFields && amountTypeFields.length && amountTypeFields.includes(columnName)) {
        text = row[columnName] ? this.shortenText(CommonUtility.formatAmount(row[columnName], this.props.app)) : CommonUtility.formatAmount("0.00", this.props.app);
      } else if (!!dateTypeFields && dateTypeFields.length && dateTypeFields.includes(columnName)) {
        text = DateUtils.dataTableDateFormatter(row[columnName]);
      } else if (!!columnCellStatic && columnCellStatic.length && columnCellStatic.includes(columnName)) {
        text = columnName;
      }
      return <Text style={[commonFontStyles.workSans, columnTableStyles.cellText, columnTableStyles.nameCellNameText, boldCells.includes(columnName) ? commonStyles.fontWeight500 : commonStyles.fontWeight400]}>{this.shortenText(text)} </Text>
    }

    render() {
      const {
        containerStyle = null,
        toggleBookmark = null,
        onProfileIcon = null,
        pageData,
        totalRows,
        page,
        rowsPerPage,
      } = this.props;

      const pagination = totalRows > rowsPerPage;

      return (
        <View style={[columnTableStyles.container, commonStyles.flex1, commonStyles.marginLtRt10, containerStyle]}>
          <View style={[columnTableStyles.table, pageData && pageData.length <= 0 && columnTableStyles.noItemsTable]}>
            {this.renderDashboardTable(pageData, pagination, onProfileIcon, toggleBookmark)}

            {/* Pagination Starts */}
            {pageData && pageData.length && !!pagination ?
              <ColumnPaginationComponent
                initializer={(pageNo, searchTxt) => this.initializer(pageNo, searchTxt)}
                page={page}
                totalRows={totalRows}
                rowsPerPage={rowsPerPage}
              />
              : null}
          </View>
        </View>
      );
    }
  }
);
